<template>
    <v-container>
        <v-layout>
            <v-flex>            
                <div>
                    <v-layout>
                        <v-flex xs12 sm6 offset-sm6>
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>           
        </v-layout>
        <h3 class="primary--text">Historial de aptitud de trabajo</h3>
        <v-data-table
                :headers="headers"
                :items="aptitudeWorkList"
                class="elevation-1"
                sort-icon="mdi-menu-down"
                :search="search"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.covidPatientId.lastName }} {{ props.item.covidPatientId.name }}</td>
                <td class="text-xs-left">{{ props.item.covidPatientId.identification }}</td>
                <td class="text-xs-left">{{ getFormattedDate(props.item.date) }}</td>
                <td class="text-xs-left">{{ props.item.comment }}</td>                
                <td class="text-xs-left">{{ props.item.nuevoEstado }}</td>   
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
            </v-alert>
        </v-data-table>
    </v-container>
</template>
<script>

    export default {
        data() {
            return {
                search: '',               
                headers: [
                    {text: 'Paciente', value: 'covidPatient.lastName'},
                    {text: 'Identificación', value: 'covidPatient.idnetification'},
                    {text: 'Fecha', value: 'date'},
                    {text: 'Comentario', value: 'comment'},
                    {text: 'Cambia a', value: 'nuevoEstado'}                    
                ],
                aptitudeWorkList: []
            };
        },
        methods: {            
            loadData(){
                this.$store.dispatch('findAptitudeWorkByCovidPatientId',this.$store.state.covidPatient.id).then(
                    response => {                        
                        this.aptitudeWorkList = response;                                              
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
            },
            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (true) {
                        // Para Safari
                        if (!(dateReg instanceof Date)) {
                            var b = dateReg.toString().split(/\D/);
                            date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                        } else {
                            date = new Date(dateReg);
                        }
                }  else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
                return str;
            }
        },
        computed: {},
        created() {
            this.loadData()
        }
    };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/covid/AptitudeWork.vue